import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslocoService } from '@ngneat/transloco';
import { HttpService } from '@web-di-ld/apps/http';
import { UiLoadingService } from 'libs/apps/http/src/lib/ui-loading.service';
import { filter, map, shareReplay } from 'rxjs/operators';
import { AppStateService } from './app-state.service';
import { pathUrl } from './configs';
import { FLOW_STATE } from './core/interfaces';
import { JsInterfaceService } from './core/services';
import { OnlineEventService } from './core/services/online-event/online-event.service';
import { DialogErrorHandlerService } from './shared/error-handler/dialog-error-handler.service';
import { HeaderControlService } from './core/services/header/HeaderControlService';

@Component({
  selector: 'web-di-ld-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(document:click)': 'handleClick($event)',
  },
})
export class AppComponent implements OnInit {
  showHeader = true;
  navigateEnd$ = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd)
  );
  urlChange$ = this.navigateEnd$.pipe(map((e) => e.urlAfterRedirects));
  titleHeader$ = this.urlChange$.pipe(
    map((path) => this.titleHeader(path)),
    shareReplay(1)
  );
  productType$ = this.httpService.productType$;
  applicationRef$ = this.httpService.applicationRef$;
  lang = 'th';
  pathUrl = pathUrl;
  share: string = 'false';
  noConnectionDialog: boolean = false;

  constructor(
    public location: Location,
    private router: Router,
    public uiLoadingService: UiLoadingService, // private route: ActivatedRoute, // private cookieService: CookieService
    private httpService: HttpService,
    private dialogErrorService: DialogErrorHandlerService,
    private appState: AppStateService,
    public translocoService: TranslocoService,
    private onlineEventService: OnlineEventService,
    private headerControlService: HeaderControlService
  ) {
    this.lang = this.translocoService.getActiveLang().toLocaleLowerCase();
  }

  isOnline = true;
  handleClick($event: any) {
    // console.log($event)
  }
  getPath(path = this.location.path()) {
    switch (path) {
      case pathUrl.loanApply.apply:
        return 'titleHeader.applyLoan';
      case pathUrl.loanApply.productDetail:
        return 'titleHeader.productDetail';
      case pathUrl.loanApply.calculation:
        return 'titleHeader.calculation';
      case pathUrl.loanApply.topup:
        return 'titleHeader.topup';
      case pathUrl.loanApply.topupDetail:
        return 'titleHeader.topup';
      case pathUrl.loanApply.topupAdditional:
        return 'titleHeader.topup';
      case pathUrl.loanApply.topupConfirm:
        return 'titleHeader.confirmingDetails';
      case pathUrl.personalInformation:
        return 'titleHeader.personalInformation';
      case pathUrl.additionalInformation:
        return 'titleHeader.additionalInformation';
      case pathUrl.editInformation:
        return 'titleHeader.editInformation';
      case pathUrl.confirmingDetails:
        return 'titleHeader.confirmingDetails';
      case pathUrl.marketingConsent:
        return 'titleHeader.consent';
      case pathUrl.peaConsent:
        return 'titleHeader.consent';
      case pathUrl.ncbConsent:
        return 'titleHeader.consent';
      case pathUrl.aisKtbTermAndCon:
        return 'titleHeader.aisKtbTermAndCon';
      case pathUrl.aisOtp:
        return 'titleHeader.aisOtp';
      case pathUrl.aisConsent:
        return 'titleHeader.consent';
      case pathUrl.confirmSummary:
        return 'titleHeader.confirmSummary';
      case pathUrl.editMailingAddress:
        return 'titleHeader.editInformation';
      case pathUrl.appInprogress:
        return 'titleHeader.appInprogress';
      case pathUrl.appDetails:
        return 'titleHeader.appDetails';
      case pathUrl.paymentDetails:
        return 'titleHeader.paymentDetails';
      case pathUrl.applySuccess:
        return 'titleHeader.applySuccess';
      case pathUrl.editAddress:
        return 'titleHeader.editAddress';
      case pathUrl.applyConfirmationInfo:
        return 'titleHeader.applyConfirmationInfo';
      case pathUrl.applyProductDetail:
        return 'titleHeader.applyProductDetail';
      case pathUrl.applyStatusPendingApprove:
        return 'titleHeader.applyStatusPendingApprove';
      case pathUrl.applyRating:
        return 'titleHeader.applyRating';
      case pathUrl.turndown:
        return 'titleHeader.turndown';
      default:
        return 'titleHeader.productShelf';
    }
  }
  titleHeader(path = this.location.path()) {
    const selLoanProduct = this.appState.snapshot.loanProduct;
    const state = this.appState.snapshot.flow?.state;
    const promotion = this.appState.snapshot.promotion;

    // FOR LOADING ON APPLY SUCCESS
    const header = this.appState.headerTitle;
    if (header === 'apply-inprogress') {
      return '';
    }

    if (promotion && path === pathUrl.promotion) {
      if (promotion.urlToShare) {
        this.share = 'true';
      }
      return promotion.title;
    }
    if (
      selLoanProduct &&
      (path === pathUrl.loanApply.apply ||
        path === pathUrl.loanApply.topupDetail)
    ) {
      return selLoanProduct.productName;
    }

    if (path === pathUrl.loanApply.topupAdditional) {
      return state !== FLOW_STATE.TOPUP_CONFIRM
        ? selLoanProduct.productName
        : 'titleHeader.editAdditionalInformation';
    }

    this.share = 'false';
    return this.getPath(path);
  }

  closeDialog() {
    this.noConnectionDialog = false;
    if (this.location.path() === pathUrl.aisOtp) {
      this.location.back();
    }
  }

  ngOnInit() {
    this.onlineEventService.startMonitoring();
    this.onlineEventService.getOnlineStatus().subscribe((isOnline: boolean) => {
      this.isOnline = isOnline;
      console.log('this.isOnline>>' + this.isOnline);
      if (!this.isOnline) {
        this.noConnectionDialog = true;
      }
    });

    this.dialogErrorService.errorLoaded.subscribe(() => {
      this.dialogErrorService.gaTagging();
    });

    this.headerControlService.showHeader$.subscribe((show) => {
      this.showHeader = show;
    });
  }
}
